import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'camber',
  title: 'Negative Camber Degrees',
  type: 'document',
  fields: [
    defineField({
      name: 'name',
      title: 'Name',
      type: 'string',
      description: 'Provide only number. Degree sign is added on render.',
      validation: (Rule) => Rule.required(),
    }),
  ],
  preview: {
    select: {
      title: 'name',
    },
    prepare(selection) {
      const { title } = selection
      return {
        title: `${title}°`,
      }
    },
  },
})
